<app-entity-field-config-list-widget
    #entityFieldConfigListWidget
    [autoFocusSearch]="false"
></app-entity-field-config-list-widget>
